import React from 'react';
import { LOGO_VERTICAL } from '../data/images';

// ── ABOUT CONTENT ─────────────────────────────────────────────
// Edit the mission statement and history text below
const ABOUT_CONTENT = {
  mission: `SHPE at Virginia Tech is a student-led organization dedicated to empowering the next generation of Hispanic engineers and scientists through professional development, academic excellence, and community impact. We build leaders who succeed in college, careers, and beyond.`,
  who: `We are Virginia Tech's chapter of the Society of Hispanic Professional Engineers. We aim to prepare future engineers and scientists by fostering academic support, networking opportunities, and community outreach for those seeking higher education.`,
  history: `Founded at Virginia Tech, SHPE@VT has grown into one of the most active engineering organizations on campus. Our chapter handles administrative and executive affairs through a student government, and at Virginia Tech, we seek to close the gap between Hispanic and non-Hispanic people in STEM.`,
  vision: `Our goal is to produce high-quality student engineers who will not only be filled with technical talent but also with awareness and the courage to better themselves and the community.`,
  // UPDATE: change the founding year and any other historical facts
  foundedYear: '2014',
  chapters: '300+', // national SHPE chapters
};

export default function About() {
  return (
    <section id="about" style={{ padding: '80px 24px', background: '#F5F0F0' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: 64, alignItems: 'center',
        }} className="about-grid">

          {/* Left: Visual */}
          <div style={{ position: 'relative' }}>
            <div style={{
              width: '100%', paddingBottom: '120%',
              background: 'linear-gradient(135deg, #861F41 0%, #5C1429 100%)',
              borderRadius: 24, overflow: 'hidden', position: 'relative',
            }}>
              {/* LOGO VERTICAL — update in src/data/images.js */}
              <img
                src={LOGO_VERTICAL}
                alt="SHPE@VT Vertical Logo"
                style={{
                  position: 'absolute', top: '50%', left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '70%', objectFit: 'contain',
                }}
                onError={e => {
                  e.target.style.display = 'none';
                }}
              />
            </div>

            {/* Stat cards */}
            <div style={{
              position: 'absolute', bottom: -24, right: -24,
              background: 'white', borderRadius: 16, padding: '20px 24px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              textAlign: 'center',
            }}>
              <div style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: 36, fontWeight: 900, color: '#E5751F',
              }}>
                {ABOUT_CONTENT.chapters}
              </div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 4, letterSpacing: 0.5 }}>
                National SHPE Chapters
              </div>
            </div>

            <div style={{
              position: 'absolute', top: -20, left: -20,
              background: '#861F41', borderRadius: 16, padding: '16px 20px',
              boxShadow: '0 8px 32px rgba(134,31,65,0.35)',
              textAlign: 'center',
            }}>
              <div style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: 28, fontWeight: 900, color: 'white',
              }}>
                Est. {ABOUT_CONTENT.foundedYear}
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 4, letterSpacing: 0.5 }}>
                at Virginia Tech
              </div>
            </div>
          </div>

          {/* Right: Text */}
          <div>
            <span className="section-label">About Us</span>
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
              fontWeight: 900, lineHeight: 1.2,
              color: '#1A1A1A', marginBottom: 24,
            }}>
              Who We Are
            </h2>

            {/* Tab sections */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>

              <AboutBlock title="Our Mission" color="#861F41">
                {ABOUT_CONTENT.mission}
              </AboutBlock>

              <AboutBlock title="Who We Are" color="#E5751F">
                {ABOUT_CONTENT.who}
              </AboutBlock>

              <AboutBlock title="Our Vision" color="#1A4A7A">
                {ABOUT_CONTENT.vision}
              </AboutBlock>

              <AboutBlock title="Our History" color="#2D7A4F">
                {ABOUT_CONTENT.history}
              </AboutBlock>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
}

function AboutBlock({ title, color, children }) {
  return (
    <div style={{
      borderLeft: `3px solid ${color}`,
      paddingLeft: 20,
    }}>
      <h3 style={{ fontSize: 15, fontWeight: 700, color, marginBottom: 8 }}>{title}</h3>
      <p style={{ fontSize: 15, color: '#555', lineHeight: 1.75 }}>{children}</p>
    </div>
  );
}
